riot.tag2('bbc-notifications-signed-in-view', '<bbc-notifications-onboarding-async if="{opts.state.onboarded === false && opts.loadOnboarding}"></bbc-notifications-onboarding-async> <bbc-notifications-onboarding-u13 if="{opts.state.onboarded === true && opts.state.policyIssue}" main-app="{opts.mainApp}" state="{opts.state}"></bbc-notifications-onboarding-u13> <bbc-notifications-onboarded-view if="{opts.state.onboarded === true && !opts.state.policyIssue}" main-app="{opts.mainApp}" component-app="{opts.componentApp}" state="{opts.state}" notifications="{opts.notifications}" reached-end="{opts.reachedEnd}" loading-more="{opts.loadingMore}" view="{opts.view}"></bbc-notifications-onboarded-view>', '', '', function(opts) {
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-signed-in-view.tag
 ** module id = 30
 ** module chunks = 0
 **/